export const elObour = {
  landmarks: [
    "سوق العبور",
    "طريق بلبيس الصحراوي",
    "كارفور العبور",
    "المنطقة الصناعية بالعبور",
    "ميدان عرابي",
    "محور العبور الرئيسي",
    "جولف سيتي"
  ],
  title: "ونش انقاذ العبور | أسرع خدمة لسوق العبور والمنطقة الصناعية",
  metaDescription: "ونش انقاذ سيارات في مدينة العبور. نقدم أوناش سحب قوية ومسطحة لخدمة سوق العبور، طريق بلبيس، والمنطقة الصناعية على مدار 24 ساعة بأفضل الأسعار.",
  intro: `مدينة العبور هي واحدة من أهم المدن الصناعية والتجارية في شرق القاهرة، حيث تشهد حركة مرورية ضخمة ومستمرة بسبب سوق العبور المركزي والمنطقة الصناعية الكبرى، بالإضافة إلى الكثافة السكانية في جولف سيتي والحي الأول. توقف أو تعطل سيارتك أو مركبتك التجارية في هذه المنطقة يتطلب خدمة ونش انقاذ سريعة وموثوقة لضمان استمرار أعمالك دون تعقيدات.
  نحن نوفر خدمة ونش انقاذ العبور بأسطول متكامل يشمل أوناش السطحة للسيارات الملاكي الحديثة، وأوناش السحب المجهزة لمركبات النقل الخفيف والنصف نقل. نتمركز بالقرب من ميدان عرابي وطريق بلبيس لنكون دائماً الأقرب إليك عند الطوارئ.`,
  highlights: [
    "تواجد مستمر بالقرب من سوق العبور للتعامل مع سيارات النقل والتجار",
    "أوناش هيدروليكية آمنة لنقل السيارات الخاصة من كارفور وجولف سيتي",
    "سرعة الوصول لأي منطقة داخل العبور خلال 15 دقيقة فقط",
    "أسعار تنافسية تناسب الجميع مع توفر الخدمة على مدار الساعة"
  ],
  safetyTips: [
    "إذا تعطلت بالقرب من سوق العبور، حاول توجيه سيارتك بعيداً عن بوابات الدخول لتجنب التكدس وحوادث سيارات النقل الثقيل.",
    "على طريق بلبيس الصحراوي، استخدم مثلث التحذير وإضاءة الفلشر وضع السيارة في حارة الأمان اليمنى.",
    "أبلغنا بحجم حمولة سيارتك (في حال كانت تجارية) لنرسل لك الونش ذو السعة المناسبة لوزن المركبة."
  ],
  faqs: [
    {
      q: "هل يتوفر لديكم ونش مخصص لسحب سيارات النصف نقل المحملة من المنطقة الصناعية بالعبور؟",
      a: "نعم، أسطولنا يتضمن أوناش سحب (Tow Trucks) ذات قدرات عالية مصممة لرفع وسحب سيارات النقل الخفيف والنصف نقل حتى وهي محملة بالبضائع."
    },
    {
      q: "ما هو الوقت المتوقع لوصول الونش إلى ميدان عرابي؟",
      a: "بفضل انتشار سيارات الإنقاذ الخاصة بنا في العبور، يمكننا الوصول إلى ميدان عرابي أو أي منطقة محيطة في غضون 10 إلى 15 دقيقة."
    },
    {
      q: "تعطلت سيارتي أمام كارفور العبور وعجلاتها مقفلة، هل السحب آمن؟",
      a: "بالتأكيد، نحن نستخدم معدات تزلج خاصة (Skates) توضع تحت الإطارات المقفلة لسحب السيارة بسلاسة إلى ونش السطحة دون التسبب في تلف ناقل الحركة."
    },
    {
      q: "هل تعملون في أيام الإجازات الرسمية والأعياد لخدمة سكان جولف سيتي؟",
      a: "نعم، خدمة ونش انقاذ العبور تعمل طوال أيام الأسبوع 24 ساعة يومياً، بما في ذلك الجمعة والأعياد والإجازات الرسمية."
    }
  ],
  seoText: `
    <h2>خدمة ونش انقاذ سيارات متكاملة في العبور</h2>
    <p>تتنوع متطلبات إنقاذ السيارات في مدينة العبور نظراً لاختلاف طبيعتها بين مناطق سكنية راقية ومناطق تجارية وصناعية مكتظة. نحن في ونش انقاذ العبور قمنا بتهيئة أسطولنا ليلبي هذه المتطلبات المتنوعة. سواء كنت عائداً من عملك في المنطقة الصناعية، أو تتسوق في كارفور، فنحن جاهزون لتقديم المساعدة الفورية.</p>

    <h3>تجهيزات مخصصة للنقل الخفيف والتجاري</h3>
    <p>سوق العبور يمثل القلب النابض لتجارة الجملة، وتعتمد عليه آلاف السيارات التجارية يومياً. تعطل سيارة محملة يمثل خسارة مضاعفة. لذلك، نخصص فرق إنقاذ مدربة للتعامل مع سيارات النقل الخفيف (مثل الدبابة والجامبو) لرفعها بأمان وسرعة، ونقلها لأقرب ورشة صيانة لضمان عودة عملك لطبيعته في أسرع وقت.</p>

    <h3>تغطية تمتد لشرق القاهرة بالكامل</h3>
    <p>موقع مدينة العبور يجعلها نقطة التقاء محورية. إذا كانت وجهتك نحو القاهرة وحدث عطل، فنحن نتعاون مع فرقنا في المناطق القريبة. يمكنك الاعتماد على <a href="/areas/السلام">ونش انقاذ السلام</a> المتمركز عند الدائري وموقف السلام لتقديم الدعم. وإذا كنت متجهاً للمناطق السكنية الجديدة، فيمكن لفريق <a href="/areas/الشروق">ونش انقاذ الشروق</a> الوصول إليك بسرعة. شبكتنا المترابطة تضمن عدم تركك عالقاً أينما كنت.</p>
    <p>احتفظ برقمنا الآن، فنحن الضمان الأسرع لعودتك للطريق بأمان.</p>
  `
};
